/*
 * @Author: 陆伟
 * @Date: 2019-11-14 11:08:52
 * @LastEditors  : 陆伟
 * @LastEditTime : 2020-01-14 10:05:28
 * @Description: 
 */
import Vue from 'vue'

/* 指令 */
Vue.directive('jurdie', {
  inserted(el) {
    document.addEventListener('click', () => el.focus(), false)
    // $(el).click(() => {
    //   el.focus();
    // })
  }
})
// 过滤
let supportWebp = false
try {
  if (global.document) {
    const ele = document.createElement('object')
    ele.type = 'image/webp'
    ele.innerHTML = '!'
    document.body.appendChild(ele)
    // 如果浏览器支持webp,那么这个object是不可见的(offsetWidth为0),
    // 否则就会显示出来,有可视宽度.
    supportWebp = !ele.offsetWidth
    document.body.removeChild(ele)
  }
} catch (err) {
  supportWebp = false
}
Vue.filter('filterWebp', (imgUrl) => {
  // 一些有可能传入空字符串
  if (!imgUrl) {
    return imgUrl
  }
  // gif不能转换成webp
  if (imgUrl.includes('.gif')) {
    return imgUrl
  }
  try {
    // 没有document相当于在服务器执行，先假定支持webp  否则在初始化渲染模板的时候要加载一遍正常的图片再加载一遍webp的图片
    if (supportWebp || !global.document) {
      const interfaceKeyWord = ['imageslim', 'imageView2', 'imageMogr2', 'imageInfo', 'exif', 'watermark', 'imageAve']
      const notProcessed = interfaceKeyWord.every(keyword => imgUrl.indexOf(keyword) === -1)
      if (notProcessed) {
        imgUrl += '?imageMogr2/format/webp'
      } else {
        imgUrl += '|imageMogr2/format/webp'
      }
    }
    return imgUrl
  } catch (e) {
    return imgUrl
  }
})
